module.exports = __webpack_public_path__ + "img/AndreLHerfurth_140x140_rund.43c80607.jpg";